import { DictionaryContent } from "../../components/config";

export default function Dictionary() {
  return (
    <>
      <DictionaryContent />
    </>
  );
}
